<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 작업계획서 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 작업계획서</h5>
      <div class="writeGridContainer">
        <div>
          <div>부서명</div>
          <p v-if="isPrint" class="print-input"> {{ form.부서명 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.부서명" :max="300" :visible-counter="true" />
        </div>
        <div>
          <div>작업명</div>
          <p v-if="isPrint" class="print-input"> {{ form.작업명 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.작업명" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>작업지휘자</div>
          <p v-if="isPrint" class="print-input"> {{ form.작업지휘자 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.작업지휘자" :max="100" :visible-counter="true" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>신호방법</div>
          <div class="gap-1">
            <div v-if="isPrint" class="flex flex-wrap gap-2 mb-2">
              <PrintCheckbox style="width: 80px;" label="수신호" :value="form.check신호방법.includes('수신호')" color />
              <PrintCheckbox style="width: 80px;" label="무선" :value="form.check신호방법.includes('무선')" color />
              <div class="flex gap-2">
                <PrintCheckbox style="width: 80px;" label="기타" :value="form.check신호방법.includes('기타')" color />
                <p v-if="form.check신호방법.includes('기타')" class="print-input">{{ form.신호방법기타 }}</p>
              </div>
            </div>
            <div v-else class="grid sm:flex flex-wrap gap-2 mb-2">
              <vs-checkbox style="width: 80px;" :readonly="board.readonly" vs-value="수신호" v-model="form.check신호방법">수신호 </vs-checkbox>
              <vs-checkbox style="width: 80px;" :readonly="board.readonly" vs-value="무선" v-model="form.check신호방법">무선 </vs-checkbox>
              <div class="flex gap-2">
                <vs-checkbox style="width: 80px;" :readonly="board.readonly" vs-value="기타" v-model="form.check신호방법" @change="onChangeCheckDate">기타</vs-checkbox>
                <ml-input :readonly="!form.check신호방법.includes('기타') || board.readonly" :isPrint="isPrint" v-model="form.신호방법기타" :max="100" :visible-counter="true" class="flex-1" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div>운반장비</div>
          <p v-if="isPrint" class="print-input"> {{ form.운반장비 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.운반장비" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>작업계획서 첨부</div>
          <p v-if="isPrint" class="print-input">{{ form.작업계획서첨부 ? form.작업계획서첨부.fileName : "" }}</p>
          <FileUploader v-else :readonly="board.readonly" v-model="form.작업계획서첨부" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  components: {
    DateSelector,
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
    DateSelectorRang,
    TimeSelector,
    PrintCheckbox,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        부서명: "",
        작업명: "",
        작업지휘자: "",
        check신호방법: [],
        신호방법기타: "",
        운반장비: "",
        작업계획서첨부: {},
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    onChangeCheckDate() {
      this.form.신호방법기타 = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.text-box {
  font-family: Noto Sans KR;
  font-size: 14px;
  font-weight: 500;
  line-height: 25.2px;
  text-align: left;

  padding: 10px;
  border: 1px solid #cdcdcd;
  margin: 28px 0;
}
</style>
